import { useCallback, useEffect } from "react";
import { useRouter } from "next/router";

import clsx from "clsx";

import ApiError from "api/Error";
import { useCheckDataFileListingNonEmpty } from "modules/data-files/api";

import { FLOW_NAME } from "flows/driver-analysis-continous/config";
import { useGetCreate } from "./api";

import {
  useInputFile,
  useGetOutcome,
  useGetCreateStatus,
  useGetCreateError,
  useResetStatus,
} from "./store";

import Divider from "ui-components/Divider";
import Button from "ui-components/Button";

import SelectData from "./Select-Data";
import OutcomeSelector from "./Select-Outcome";

const CreateProject = () => {
  const router = useRouter();
  const data = router.query.data as string;
  const { push, pathname } = router;

  const reset = useResetStatus();

  useEffect(() => {
    reset();
  }, []);

  const [, setCurrentFile] = useInputFile();
  const outcome = useGetOutcome();
  const createProject = useGetCreate();
  const submitStatus = useGetCreateStatus();
  const error = useGetCreateError();

  useEffect(() => {
    if (data) {
      setCurrentFile(data);
    }
  }, [data]);

  const create = useCallback(async () => {
    const resp = await createProject();
    if (resp?.success) {
      push(`/${FLOW_NAME}/${resp.project.id}`);
    }
  }, [createProject, push]);

  const dataFilesPresent = useCheckDataFileListingNonEmpty();

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="pb-4 mb-8">
        <h1 className="h2 text-center">Start Driver Analysis</h1>
      </div>
      <SelectData />
      {dataFilesPresent && (
        <>
          <Divider />
          <OutcomeSelector />
          {submitStatus === "completed" && error && <ApiError error={error} />}
          <div className="w-full px-3 my-4 py-4">
            <Button
              className={clsx(
                "w-full text-gray-100",
                !outcome ? "bg-indigo-400" : "bg-indigo-600",
                outcome &&
                  submitStatus !== "in-progress" &&
                  "hover:bg-indigo-800"
              )}
              disabled={!outcome}
              loading={submitStatus === "in-progress"}
              onClick={create}
            >
              {submitStatus === "in-progress"
                ? "Creating..."
                : "Create New Project"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateProject;
